export default {
    reg_phone(val) {
        const validate = /\d{4}\d{3}\d{3}/
        return validate.test(val)
    },
    reg_email(val) {
        const validate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        return validate.test(val)
    },
    // Password validation: At least 8 characters, with uppercase, lowercase, and a number
    reg_password(val) {
        const validate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
        return validate.test(val)
    },
    // Account validation: 4-50 characters, alphanumeric
    reg_account(val) {
        const validate = /^[a-zA-Z0-9]{4,50}$/
        return validate.test(val)
    },
}